import axios from "axios";
import { isAfterTenMinutes } from "./utils";

export const postEvent = (
  eventName: string,
  userID: string,
  properties: any
) => {
  const timestamp = sessionStorage.getItem("session_timestamp");
  !timestamp ||
    (Number(timestamp) === 0 &&
      sessionStorage.setItem("session_timestamp", String(Date.now())));
  isAfterTenMinutes(Number(sessionStorage.getItem("session_timestamp"))) &&
    sessionStorage.setItem("session_timestamp", String(Date.now()));

  return axios
    .post(
      `v1/analytics/events`,
      {
        events: [
          {
            event_type: eventName,
            properties: properties,
          },
        ],
      },
      {
        headers: {
          "X-Device-Id": navigator.userAgent,
          "X-Mobile-SessionId": `${userID}_${Number(
            sessionStorage.getItem("session_timestamp")
          )}`,
        },
      }
    )
    .catch((e: any) => {});
};
